<template>
  <div class="mx-0 px-0">
    <v-form @submit.prevent="submitComment">
      <v-textarea
        v-model="comment"
        outlined
        single-line
        auto-grow
        rows="1"
        no-resize
        placeholder="Leave a comment">
        <template v-slot:append>
          <v-btn icon small :disabled="!comment.trim()" @click="submitComment" class="mt-n1">
            <v-icon>{{ icons.mdiSend }}</v-icon>
          </v-btn>
        </template>
      </v-textarea>
    </v-form>
  </div>
</template>

<script>
import { mdiSend } from '@mdi/js';
export default {
  data() {
    return {
      comment: '',
      icons:{
        mdiSend: mdiSend
      }
    };
  },
  methods: {
    submitComment() {
      if (!this.comment.trim()) return;
      this.$emit('comment-submitted', this.comment);
      this.comment = '';
    }
  }
};
</script>

<style scoped>
/* You might need to add custom styles here */
</style>
